<template>
  <div class="text-3xl font-extrabold">
    <span
      class="
        bg-clip-text
        text-transparent
        bg-gradient-to-r
        from-green-400
        to-blue-500
      "
    >
      Документы для оформления:
    </span>
  </div>

  <div id="accordion" class="tomu-accordion space-y-2">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="tomu-accordion-item"
      :class="{ active: item.active }"
    >
      <div
        class="tomu-accordion-header cursor-pointer"
        @click="item.active = !item.active"
      >
        <div
          class="select-none grid"
          style="grid-template-columns: min-content auto"
        >
          <div>
            <svg
              class="w-8 text-blue-400 fill-current transform duration-300"
              :class="{
                'rotate-90': item.active,
                'text-blue-600': item.active,
              }"
              viewBox="0 0 72 72"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M31.853 29.874V12.521H42.15v17.36h.048l4.051.002h13.357V40.18H46.256l-4.107-.003v18.675H31.853V40.17h-.1l-3.817-.002H14V29.87h13.933l3.836.003z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                stroke-width="2"
                d="M31.853 29.874V12.521H42.15v17.36h.048l4.051.002h13.357V40.18H46.256l-4.107-.003v18.675H31.853V40.17h-.1l-3.817-.002H14V29.87h13.933l3.836.003z"
              />
            </svg>
          </div>
          <div>
            <span
              class="
                text-2xl
                border-dashed border-b-2 border-blue-400
                hover:border-blue-600
              "
              >{{ item.header.text }}</span
            >
          </div>
          <div class="col-start-2">
            <div v-show="item.active" class="tomu-accordion-content">
              <h3 v-show="item.content.title">{{ item.content.title }}</h3>
              <p v-show="item.content.description">
                {{ item.content.description }}
              </p>
              <ul v-show="item.content.list">
                <li v-for="(itemText, index) in item.content.list" :key="index">
                  {{ itemText }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DigitalDriverCardsNecessaryDocuments",
  data() {
    return {
      items: [
        {
          active: false,
          header: {
            text: "Карта водителя",
          },
          content: {
            title: "",
            description: "",
            list: [
              "Копия основного документа, удостоверяющего личность (стр. основного разворота + стр. регистрации)",
              "Копия водительского удостоверения (лицевая сторона)",
              "Копия документа, подтверждающего регистрацию в системе индивидуального учета (АДИ-РЕГ) /страхового свидетельства обязательного пенсионного страхования (СНИЛС)",
              "Копия ранее выданной карты водителя (если имеется)",
              "Надлежащим образом, заверенный перевод на русский язык документов (для иностранных граждан)",
              "Фотография (четкая на светлом фоне)",
            ],
          },
        },
        {
          active: false,
          header: {
            text: "Карта предприятия",
          },
          content: {
            title: "",
            description: "",
            list: [
              "Копия основного документа, удостоверяющего личность (Заявителя)",
              "Копия документа, подтверждающего регистрацию в системе индивидуального учета (АДИ-РЕГ)/копия страхового свидетельства обязательного пенсионного страхования (СНИЛС) (для физического лица)",
              "Копия Свидетельства о государственной регистрации юридического лица (индивидуального предпринимателя) с присвоением Основного государственного регистрационного номера (индивидуального предпринимателя) (ОГРН/ОГРНИП)",
              "Копия свидетельства (уведомления) о постановке на учет в налоговом органе на территории Российской Федерации (ИНН)",
              "Копия документа о назначении лица, ответственным за эксплуатацию тахографов (для юридических лиц или индивидуальных предпринимателей) (при наличии)",
              "Надлежащим образом, заверенный перевод на русский язык документов о государственной регистрации юридического лица в соответствии с законодательством иностранного государства (для иностранных юридических лиц)",
              "Доверенность или иной документ, подтверждающий право заявителя действовать от имени юридического лица или индивидуального предпринимателя",
            ],
          },
        },
        {
          active: false,
          header: {
            text: "Карта мастерской",
          },
          content: {
            title: "",
            description: "",
            list: [
              "Копия основного документа, удостоверяющего личность (Заявителя)",
              "Копия Свидетельства о государственной регистрации юридического лица (индивидуального предпринимателя) с присвоением Основного государственного регистрационного номера (индивидуального предпринимателя) (ОГРН/ОГРНИП)",
              "Копия свидетельства (уведомления) о постановке на учет в налоговом органе на территории Российской Федерации (ИНН)",
              "Копия Лицензии ФСБ России на выполнение работ, предусмотренных пунктами 12, 20, 21 Перечня выполняемых работ и оказываемых услуг, составляющих лицензируемую деятельность, в отношении шифровальных (криптографических) средств, являющегося приложением к Положению, утвержденному постановлением Правительства РФ от 16 апреля 2012г. № 313",
              "Копия документа о назначении руководителя мастерской. 6. Доверенность или иной документ, подтверждающий право заявителя действовать от имени юридического лица или индивидуального предпринимателя",
            ],
          },
        },
      ],
    };
  },
};
</script>

<style scoped></style>
